import {ComponentPropsWithoutRef, forwardRef} from "react";

interface FormControlProps extends ComponentPropsWithoutRef<'input'> {
  small?: boolean;
}

const FormControl = forwardRef<HTMLInputElement, FormControlProps>((props, ref) => {
  return (
    <input
      {...props}
      ref={ref} // 전달받은 ref를 input에 연결
      type={props.type ?? 'text'}
      className={`form-control ${props.small ? 'form-control-sm' : ''}`}
    />
  );
});

export default FormControl;